import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { ChevronDown, ChevronRight, FileText, Check } from "lucide-react";
import { toast } from "sonner";
import { Q, fotoUrl } from "./util";

export const OpFila = ({ op, onChanged, sel, onSel }) => {
  const [open, setOpen] = useState(op.n > 1);
  const tid = op.operacion;
  const patch = async (body) => {
    try { await api.patch(`/mi-dinero/liquidaciones/${op.operacion}`, { empresa: op.empresa, ...body }); onChanged(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const facturar = async () => {
    try {
      const { data } = await api.post(`/mi-dinero/liquidaciones/${op.operacion}/facturar`, null, { params: { empresa: op.empresa } });
      toast.success(data.resultado.map((r) => `${r.pedido}: ${r.estado}`).join(" · ") || "Sin cambios"); onChanged();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const conf = op.estado === "confirmado";
  const facturada = Object.keys(op.facturas || {}).length > 0;
  const g0 = op.guias[0];
  return (
    <tbody className={`border-t-4 border-white ${facturada ? "bg-emerald-50" : "bg-white"}`} data-testid={`op-${tid}`}>
      <tr>
        <td colSpan={7} className="px-2 pt-2">
          {!op.deposito_id && <input type="checkbox" checked={!!sel} onChange={(e) => onSel(e.target.checked)} className="mr-2 align-middle w-4 h-4" data-testid={`op-sel-${tid}`} />}
          <button onClick={() => setOpen(!open)} className="inline-flex items-center gap-1 font-black" data-testid={`op-toggle-${tid}`}>
            {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}Operación: {op.operacion}
            <span className="font-normal text-xs ml-1">({op.n} guía{op.n > 1 ? "s" : ""})</span>
          </button>
        </td>
        <td rowSpan={(open ? op.n : 1) + 1} className="bg-amber-100 text-center font-black text-lg px-2" data-testid={`op-total-${tid}`}>
          <Q v={op.total} />
          {op.anticipos > 0 && <div className="text-[10px] font-semibold text-zinc-700" data-testid={`op-anticipos-${tid}`}>Anticipos ya recibidos: <Q v={op.anticipos} /></div>}
        </td>
        <td rowSpan={(open ? op.n : 1) + 1} className="px-1 text-xs font-semibold" data-testid={`op-banco-${tid}`}>{op.banco || "—"}</td>
        <td rowSpan={(open ? op.n : 1) + 1} className="px-1 text-xs tabular-nums" data-testid={`op-numdep-${tid}`}>{op.num_deposito || <span className="text-zinc-400">Sin depósito</span>}</td>
        <td rowSpan={(open ? op.n : 1) + 1} className="px-1 text-xs whitespace-nowrap" data-testid={`op-fechadep-${tid}`}>{op.fecha_deposito || "—"}</td>
        <td rowSpan={(open ? op.n : 1) + 1} className="px-1">
          <select value={op.estado} disabled={facturada || !op.deposito_id} onChange={(e) => patch({ estado: e.target.value })} className={`rounded-full px-2 py-1 text-xs font-bold border ${conf ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-900"}`} data-testid={`op-estado-${tid}`}>
            <option value="por_confirmar">Por confirmar</option><option value="confirmado">Confirmado</option>
          </select>
        </td>
        <td rowSpan={(open ? op.n : 1) + 1} className="px-1 text-center">
          {op.foto ? <a href={fotoUrl(op.foto)} target="_blank" rel="noreferrer"><img src={fotoUrl(op.foto)} alt="" className="w-10 h-10 object-cover rounded border mx-auto" /></a> : <span className="text-[10px] text-zinc-400">Con el depósito</span>}
        </td>
        <td rowSpan={(open ? op.n : 1) + 1} className="px-1 text-center">
          {facturada ? <div className="text-[10px]"><span className="inline-flex items-center gap-1 rounded bg-violet-700 text-white px-2 py-1 font-bold"><Check className="w-3 h-3" />Facturada</span><div>{Object.values(op.facturas).join(", ")}</div></div>
            : <button disabled={!conf || !op.foto} onClick={facturar} className={`inline-flex items-center gap-1 rounded px-2 py-1 text-xs font-bold ${conf && op.foto ? "bg-emerald-600 text-white" : "bg-zinc-200 text-zinc-500"}`} data-testid={`op-facturar-${tid}`}><FileText className="w-3 h-3" />Facturar</button>}
        </td>
      </tr>
      {(open ? op.guias : [g0]).map((g) => (
        <tr key={g.guia} className="text-xs" data-testid={`guia-${g.guia}`}>
          <td className="px-2 py-1 font-semibold">{g.cliente}</td>
          <td className="px-1 whitespace-nowrap">{g.pedido ? <span className="rounded bg-violet-600 text-white px-1.5 py-0.5 font-bold">{g.pedido}</span> : <span className="text-red-600 font-bold">Sin pedido</span>}
            {g.anticipo > 0 && <div className="text-[10px] text-zinc-600" data-testid={`guia-anticipo-${g.guia}`}>Anticipo <Q v={g.anticipo} /> {g.anticipo_banco}</div>}
            {g.saldo_pedido !== null && g.saldo_pedido !== undefined && <div className="text-[10px] text-zinc-600">Saldo pedido <Q v={g.saldo_pedido} /></div>}
          </td>
          <td className="px-1 tabular-nums whitespace-nowrap">{g.guia}</td>
          <td className="px-1 tabular-nums">{g.operacion}</td>
          <td className="px-1 text-right whitespace-nowrap"><Q v={g.cod} /></td>
          <td className="px-1 text-right whitespace-nowrap"><Q v={g.comision} /></td>
          <td className="px-1 text-right font-bold whitespace-nowrap"><Q v={g.neto} /></td>
        </tr>
      ))}
    </tbody>
  );
};
